import { render, staticRenderFns } from "./OrdersRounds.vue?vue&type=template&id=4791e006&"
import script from "./OrdersRounds.vue?vue&type=script&lang=js&"
export * from "./OrdersRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports